import { useEffect } from 'react';
import { rootContainer } from 'app/shadowRoot';
import { useTailorHasOpened } from 'app/hooks/useTailorHasOpened';
import { useTailorIsOpen } from 'app/hooks/useTailorIsOpen';

export default function useTailorToggleEffect() {
  const { isOpen, setIsOpen } = useTailorIsOpen();
  const { hasOpened, setHasOpened } = useTailorHasOpened();

  useEffect(() => {
    const handleToggle = ({ detail }: Event & { detail: boolean }) => {
      setIsOpen(detail ?? !isOpen);
      if (!hasOpened && (detail ?? !isOpen)) {
        setHasOpened(true);
      }
    };

    rootContainer.addEventListener('tailor:toggle', handleToggle as EventListener);

    return () => {
      rootContainer.removeEventListener('tailor:toggle', handleToggle as EventListener);
    };
  }, [isOpen, hasOpened, setIsOpen, setHasOpened]);
}
